<template>
  <div class="overflow-hidden text-xs w-full py-2 px-2 bg-gray-200 rounded text-gray-700 placeholder-neutral-700 min-h-1/4">
    <div class="flex flex-wrap w-full">
      <tag
        v-for="tagText in alphabetOrderedTagList"
        :key="tagText"
        :tag-name="tagText"
        @remove="removeTag(tagText)"
      />
    </div>
    <input
      v-model="inputValue"
      type="text"
      class="w-full py-2 px-2 bg-gray-200 rounded text-gray-700 placeholder-neutral-700 min-h-1/4"
      :placeholder="tagList.length > 0 ? '' : placeholder"
      @keyup.enter.prevent="addTags"
      @blur="addTags"
    >
  </div>
</template>

<script>
import Tag from './Tag.vue'
export default {
  components: {
    Tag
  },
  props: {
    tagList: { type: Array, default: () => [] },
    placeholder: { type: String, default: null }
  },
  data () {
    return {
      inputValue: ''
    }
  },
  computed: {
    alphabetOrderedTagList () {
      return [...this.tagList].sort((a, b) => a.localeCompare(b))
    }
  },
  methods: {
    removeTag: function (tagTextToDelete) {
      this.$emit('removeTag', tagTextToDelete)
    },
    addTags: function () {
      const newTags = (this.inputValue || '').split(/,|;/).map(tag => tag.trim()).filter(tag => tag !== '')
      this.$emit('input', newTags)
      this.inputValue = null
    }
  }
}
</script>
